import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Xport',
      component: () => import('./views/home/index.vue')
    },
    {
      path: '/platform',
      name: 'Platform',
      component: () => import('./views/platform/index.vue')
    },
    {
      path: '/success-stories',
      name: 'SuccessStories',
      component: () => import('./views/success-stories/index.vue')
    },
    {
      path: '/story-detail',
      name: 'StoryDetail',
      component: () => import('./views/success-stories/storyDetail.vue')
    },
    {
      path: '/storydetail',
      name: 'storydetail',
      component: () => import('./views/success-stories/detail.vue')
    },
    {
      path: '/knowledge-centre',
      name: 'KnowledgeCentre',
      component: () => import('./views/knowledge-centre/index.vue')
    },
    {
      path: '/knowledge-detail',
      name: 'KnowledgeDetail',
      component: () => import('./views/knowledge-centre/detail.vue')
    },
    {
      path: '/partners',
      name: 'Partners',
      component: () => import('./views/partners/index.vue')
    },
    {
      path: '/about',
      name: 'XportAbout',
      component: () => import('./views/about/index.vue')
    },
    {
      path: '/contact-us',
      name: 'ContactUs',
      component: () => import('./views/contact-us/index.vue')
    },
    {
      path: '/careers',
      name: 'Careers',
      component: () => import('./views/careers/index.vue')
    },
    {
      path: '/media-center',
      name: 'MediaCenter',
      component: () => import('./views/media-center/index.vue')
    },
    {
      path: '/scheduler',
      name: 'Scheduler',
      component: () => import('./views/scheduler/index.vue')
    },
    {
      path: '/customs',
      name: 'Customs',
      component: () => import('./views/customs/index.vue')
    },
    {
      path: '/tradeCompliance',
      name: 'tradeCompliance',
      component: () => import('./views/tradeCompliance/index.vue')
    },
    {
      path: '/consultation',
      name: 'consultation',
      component: () => import('./views/consultation/index.vue')
    }
  ]
})
